import { Designer } from "@brg/api";
import { FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "../styles";
import { Avatar, DropdownListItem, FlexBox } from "@brg/ui";
import styled from "styled-components";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useHistory } from "react-router-dom";
import { computeDesigner } from "shared/helpers/computeData";
import ClickAwayListener from "shared/pages/ChildrensBooks/components/ui/ClickAwayListener";
import { LayoutConst } from "core";

const MAX_OWNERS_LINKS_IN_ROW = 2;

const Container = styled(FlexBox)`
    position: relative;

    svg {
        width: 12px;
        height: 12px;
    }
`;

const AvatarWrapper = styled.div`
    width: 40px;
    height: 40px;
`;

const AvatarName = styled.div``;

const Dropdown = styled(ClickAwayListener)<{ visible?: boolean }>`
    display: ${({ visible }) => visible ? 'flex' : 'none'};
    flex-flow: column;
    position: absolute;
    top: 33px;
    left: 0;
    // transform: translateX(-50%);
    width: 396px;
    max-height: 176px;
    overflow-y: auto;
    z-index: 9999;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        left: 0;
        transform: none;
        max-width: calc(100vw - 20px);
    }
    

    ${DropdownListItem} {
        width: 100%;
        padding: 2px 16px;
        display: flex;
        flex-flow: row;
        min-height: 44px;

        &:hover {
            background-color: #E7E7E7;
        }

        ${AvatarName} {
            color: #70706F;
            font-family: Inter;
            font-size: 15px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px; /* 133.333% */
            letter-spacing: -0.3px;
            
        }
    }
`;

export const OwnersList: FC<{ owners: Designer[]}> = ({ owners }) => {
    const history = useHistory();
    const { t, i18n: { language }} = useTranslation();
    const [visible, setVisible] = useState(false);

    const computeDesigners = useMemo(() => {
        return owners?.map((owner) => computeDesigner(owner))
    } , [language, owners])

    const ownersDropdown = useMemo(() => {
        return computeDesigners?.map((designer) => {
            return (
                <DropdownListItem 
                    key={designer?.accountId} 
                    onClick={() => history.push(CreateLinkTo.designer(designer?.accountId))}
                >
                    <AvatarWrapper>
                        <Avatar 
                            {...designer}
                            avatar={designer.avatar} 
                            rounded
                        />
                    </AvatarWrapper>
                    <AvatarName>
                        {`${designer?.name || ''} ${designer?.surName || ''}`}
                    </AvatarName>
                </DropdownListItem>
            )
        })
    } , [language, computeDesigners])

    const handleChange = () => {
        setVisible(!visible)
    }

    if (computeDesigners?.length <= MAX_OWNERS_LINKS_IN_ROW) {
        return (
            <Container gx={8} direction="row">
                {computeDesigners?.map((designer) => (
            <Link
                to={`/designer/${designer?.accountId}`}
            >
                {`${designer?.name || ''} ${designer?.surName || ''}`}
            </Link>
        ))}
            </Container>
        )
    }

    return (
        <Container direction="column" gy={11} gyMobile={11}>
            <ArrowTopIconWithText 
                text={t('autochannels.tabs.teachers')} 
                shrimpIcon 
                onClick={handleChange}
            />
            <Dropdown visible={visible} onClickAway={() => setVisible(false)}>
                {ownersDropdown}
            </Dropdown>
        </Container>
    )
}import { Designer } from "@brg/api";
import { FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "../styles";
import { Avatar, DropdownListItem, FlexBox } from "@brg/ui";
import styled from "styled-components";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useHistory } from "react-router-dom";
import { computeDesigner } from "shared/helpers/computeData";
import ClickAwayListener from "shared/pages/ChildrensBooks/components/ui/ClickAwayListener";
import { LayoutConst } from "core";

const MAX_OWNERS_LINKS_IN_ROW = 2;

const Container = styled(FlexBox)`
    position: relative;

    svg {
        width: 12px;
        height: 12px;
    }
`;

const AvatarWrapper = styled.div`
    width: 40px;
    height: 40px;
`;

const AvatarName = styled.div``;

const Dropdown = styled(ClickAwayListener)<{ visible?: boolean }>`
    display: ${({ visible }) => visible ? 'flex' : 'none'};
    flex-flow: column;
    position: absolute;
    top: 33px;
    left: 0;
    // transform: translateX(-50%);
    width: 396px;
    max-height: 176px;
    overflow-y: auto;
    z-index: 9999;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        left: 0;
        transform: none;
        max-width: calc(100vw - 20px);
    }
    

    ${DropdownListItem} {
        width: 100%;
        padding: 2px 16px;
        display: flex;
        flex-flow: row;
        min-height: 44px;

        &:hover {
            background-color: #E7E7E7;
        }

        ${AvatarName} {
            color: #70706F;
            font-family: Inter;
            font-size: 15px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px; /* 133.333% */
            letter-spacing: -0.3px;
            
        }
    }
`;

export const OwnersList: FC<{ owners: Designer[]}> = ({ owners }) => {
    const history = useHistory();
    const { t, i18n: { language }} = useTranslation();
    const [visible, setVisible] = useState(false);

    const computeDesigners = useMemo(() => {
        return owners?.map((owner) => computeDesigner(owner))
    } , [language, owners])

    const ownersDropdown = useMemo(() => {
        return computeDesigners?.map((designer) => {
            return (
                <DropdownListItem 
                    key={designer?.accountId} 
                    onClick={() => history.push(CreateLinkTo.designer(designer?.accountId))}
                >
                    <AvatarWrapper>
                        <Avatar 
                            {...designer}
                            avatar={designer.avatar} 
                            rounded
                        />
                    </AvatarWrapper>
                    <AvatarName>
                        {`${designer?.name || ''} ${designer?.surName || ''}`}
                    </AvatarName>
                </DropdownListItem>
            )
        })
    } , [language, computeDesigners])

    const handleChange = () => {
        setVisible(!visible)
    }

    if (computeDesigners?.length <= MAX_OWNERS_LINKS_IN_ROW) {
        return (
            <Container gx={8} direction="row">
                {computeDesigners?.map((designer) => (
            <Link
                to={`/designer/${designer?.accountId}`}
            >
                {`${designer?.name || ''} ${designer?.surName || ''}`}
            </Link>
        ))}
            </Container>
        )
    }

    return (
        <Container direction="column" gy={11} gyMobile={11}>
            <ArrowTopIconWithText 
                text={t('autochannels.tabs.teachers')} 
                shrimpIcon 
                onClick={handleChange}
            />
            <Dropdown visible={visible} onClickAway={() => setVisible(false)}>
                {ownersDropdown}
            </Dropdown>
        </Container>
    )
}